import http from '@/support/plugin/axios'

export const

//definir geolocalização
updateLocationByCurrentId = (contactLocationDto) => {
    const body = {
        latitude: contactLocationDto.latitude,
        longitude: contactLocationDto.longitude
    }
    
    return http.patch('contacts/current/location', body)
}